import "./Page.css";
import React, { useState, useRef } from "react";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Sidenav from "../examples/Sidenav";
import brandWhite from "assets/images/logo-ct.png";

import { useMaterialUIController, setMiniSidenav } from "../context";

import { IconButton, TextareaAutosize, Tooltip } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { GetWrite } from "api/UserAPI";
import { GetDocument } from "api/DocumentAPI";
import { useParams } from "react-router-dom";
import { UpdateDocument } from "api/DocumentAPI";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Loader } from "components/loader/Loader";
import ReferencesPanel from "components/document/ReferencesPanel";

function Page() {
  const [info, setInfo] = React.useState("");
  const [variables, setVariables] = React.useState({});
  const [showReferences, setShowReferences] = useState(false);
  const contentRef = useRef(null);
  const cursorPos = useRef(null);

  const { getWrite, writeLoading } = GetWrite(setInfo);
  const [errors, setErrors] = React.useState({});
  const { updateDocument, updateLoading } = UpdateDocument(setErrors);

  const { id } = useParams();

  React.useEffect(() => {
    if (variables?.type) updateDocument({ variables });
  }, [variables]);

  const { documentData, documentLoading } = GetDocument(id);

  React.useEffect(() => {
    setVariables(documentData?.getDocument);
  }, [!documentData]);

  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const handleWrite = () => {
    getWrite({ variables });
  };

  const handleAccept = () => {
    setVariables({ ...variables, content: (variables.content ?? "") + info });
    setInfo("");
  };
  const handleReject = () => setInfo("");
  const handleRegenerate = () => {
    setInfo("Loading ...");
    handleWrite();
  };

  // Parse references JSON safely
  const references = React.useMemo(() => {
    try {
      return JSON.parse(variables?.references || "[]");
    } catch {
      return [];
    }
  }, [variables?.references]);

  const handleReferencesChange = (updatedRefs) => {
    setVariables({ ...variables, references: JSON.stringify(updatedRefs) });
  };

  const handleInsertCitation = (citation) => {
    const pos = cursorPos.current ?? (variables?.content?.length ?? 0);
    const content = variables?.content ?? "";
    const newContent = content.slice(0, pos) + " " + citation + content.slice(pos);
    cursorPos.current = pos + citation.length + 1;
    setVariables({ ...variables, content: newContent });
  };

  const handleContentChange = (e) => {
    cursorPos.current = e.target.selectionStart;
    setVariables({ ...variables, content: e.target.value });
  };

  const handleContentSelect = (e) => {
    cursorPos.current = e.target.selectionStart;
  };

  return (
    <>
      {documentLoading ? (
        <div style={{ display: "flex", justifyContent: "center", margin: "100px" }}>
          <Loader />
        </div>
      ) : (
        <>
          <DashboardNavbar page={variables?.title} />
          <Sidenav
            color={sidenavColor}
            brand={brandWhite}
            brandName=""
            routes={[]}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
            vars={variables}
            setVars={setVariables}
            handleWrite={handleWrite}
            writeLoading={writeLoading}
          />
          <div style={{ backgroundColor: "white", display: "flex", flex: 1 }}>
            <DashboardLayout>
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                {/* Editor area */}
                <div style={{ color: "gray", maxWidth: "700px", width: "100%", flex: 1 }}>
                  <div style={{ marginBottom: 40 }}>
                    <TextareaAutosize
                      className="writing-title text-font-style"
                      placeholder="Enter Your Title ..."
                      value={variables?.title ?? ""}
                      onChange={(e) => setVariables({ ...variables, title: e.target.value })}
                      rows="1"
                      style={{
                        overflow: "hidden",
                        overflowWrap: "break-word",
                        width: "100%",
                        border: "0px",
                      }}
                    />
                  </div>
                  <div>
                    <TextareaAutosize
                      ref={contentRef}
                      className="writing-desc text-font-style"
                      placeholder="Write here ..."
                      onChange={handleContentChange}
                      onSelect={handleContentSelect}
                      value={variables?.content ?? ""}
                      rows="1"
                      style={{
                        overflow: "hidden",
                        overflowWrap: "break-word",
                        width: "100%",
                        border: "0px",
                      }}
                    />
                  </div>
                  {info && (
                    <div
                      className={info ? "text-faded-in" : "text-faded-out"}
                      style={{ backgroundColor: "#d5d9ff", padding: 10, borderRadius: 10 }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          justifyContent: "flex-end",
                          backgroundColor: "white",
                          borderRadius: 10,
                          marginBottom: 10,
                        }}
                      >
                        <div onClick={handleAccept} className="text-button">
                          Accept
                        </div>
                        <div onClick={handleReject} className="text-button">
                          Reject
                        </div>
                        <div onClick={handleRegenerate} className="text-button">
                          {writeLoading ? "Loading..." : "Regenerate"}
                        </div>
                      </div>
                      <p>{info}</p>
                    </div>
                  )}
                  <div style={{ marginBottom: "350px" }}></div>
                </div>

                {/* References toggle */}
                <div style={{ position: "sticky", top: 80, marginLeft: 16, flexShrink: 0 }}>
                  <Tooltip title={showReferences ? "Hide references" : "Show references"}>
                    <IconButton
                      onClick={() => setShowReferences(!showReferences)}
                      style={{
                        backgroundColor: showReferences ? "#012042" : "#f0f0f0",
                        color: showReferences ? "white" : "#012042",
                        borderRadius: 8,
                        transition: "0.2s ease all",
                      }}
                    >
                      <MenuBookIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            </DashboardLayout>

            {/* References panel */}
            {showReferences && (
              <ReferencesPanel
                references={references}
                onChange={handleReferencesChange}
                onInsertCitation={handleInsertCitation}
              />
            )}
          </div>
        </>
      )}
    </>
  );
}

export default Page;
